export default {
    storeTopResume(context, data) {
        const url = 'v1/me/partners/top-resume';
        return this.$axios.$post(url, data);
    },
};
